export default __webpack_public_path__ + "static/media/horizontal_lighttodark.8eaf2b60.png";